import type { User } from "@core/account/types";

export function useCommentAvatar(user?: Partial<User>) {
  const name = user?.name || "";

  return {
    imageUrl: user?.image?.url,
    initial: name.trim().charAt(0).toUpperCase(),
    name,
  };
}
